import { PenLine, Workflow } from 'lucide-react';

const ORIGIN_CONFIG = {
  casted: {
    label: 'Casted',
    icon: PenLine,
    className: 'bg-slate-100 text-slate-700 border-slate-200',
  },
  eventflow: {
    label: 'Event Flow',
    icon: Workflow,
    className: 'bg-violet-100 text-violet-700 border-violet-200',
  },
};

const SIZES = {
  sm: 'text-xs px-2 py-0.5 gap-1',
  md: 'text-sm px-2.5 py-1 gap-1.5',
};

export default function OriginBadge({ origin, size = 'sm', className = '' }) {
  const config = ORIGIN_CONFIG[origin] || ORIGIN_CONFIG.casted;
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center rounded-full border font-medium ${config.className} ${SIZES[size] || SIZES.sm} ${className}`}
    >
      <Icon size={size === 'md' ? 13 : 11} />
      {config.label}
    </span>
  );
}